export const GET_ADVISORS = 'GET_ADVISORS'
export const CREATE_ADVISOR = 'CREATE_ADVISOR'
export const EDIT_ADVISOR = 'EDIT_ADVISOR'
export const ENABLE_ADVISOR = 'ENABLE_ADVISOR'
export const DISABLE_ADVISOR = 'DISABLE_ADVISOR'
export const ENABLE_ADVISOR_CLIENT = 'ENABLE_ADVISOR_CLIENT'
export const DISABLE_ADVISOR_CLIENT = 'DISABLE_ADVISOR_CLIENT'
export const SET_ADVISOR = 'SET_ADVISOR'
export const SET_CLIENTS = 'SET_CLIENTS'


// WEBPACK FOOTER //
// ./src/store/modules/Conseillers/types.js